import React, { useEffect, useRef, useState } from "react";
import ShippingAddressForm from "./shipping";
import StripePay from "./stripe/Stripe";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import axios from "axios";
import { toast } from "react-toastify";
import { PAYMENTSERVER, URL, VENDORID } from "../constants";
import { Text } from "../languages/Language";

var steps = [];

const CheckoutScreen = ({ amount, table, props, paymentType }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [checkPayment, setCheckPayment] = useState(0);
    const [data, setData] = useState(null);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
    const [startPayment, setStartPayment] = useState(0);
    const stripeRef = useRef();
    const [isPayPalModalOpen, setPayPalModalOpen] = useState(false);

    const [terms, setTerms] = useState(false);

    const [paymentTrackingId, setPaymentTrackingId] = useState("");

    const [address, setAddress] = useState({
        recipient: "",
        street: "",
        zip: "",
        city: "",
        country: "",
        countryCode: "",
        firstName: "",
        lastName: "",
        type: "Adresse",
        useBillingAddress: false,
    });

    useEffect(() => {
        setData(JSON.parse(sessionStorage.getItem('user')))
        if (paymentType === "stripe_embed") {
            steps = [<Text tid={"Address"} />, <Text tid={"Payment"} />, <Text tid={"Approve"} />];
        }
        if (paymentType === "paypal" || paymentType === "stripe") {
            steps = [<Text tid={"Payment"} />];
        }
    }, []);


    const handlePaymentSuccess = () => {
        toast.success(<Text tid={"PaymentSuccess"} />)
        props.ShowDetailedBasket(false);
        props.toggleLoadingOverlay(true);
        const url = URL;

        const requestOptions = {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: JSON.stringify({
                "serviceId": 4003, //Slip Send //4003
                "token": sessionStorage.getItem('token'),
                "vendorId": VENDORID,
                "slipRef": sessionStorage.getItem('slipRef'),
                "erpGenExpl1": sessionStorage.getItem('Expl1') ?? "",
                "erpGenExpl2": sessionStorage.getItem('Expl2') ?? "",
                "paymentTrackingId": paymentTrackingId ?? "",
                "paymentMethod": paymentType ?? ""
            })
        };

        const fetchData = async () => {
            try {
                const response = await fetch(url, requestOptions);
                const json = await response.json();

                if (json.resCode == 200) {
                    sessionStorage.setItem('slipRef', json.dataSet[0]?.slipRef);
                    sessionStorage.removeItem('Expl1');
                    sessionStorage.removeItem('Expl2');

                    toast.success(<><Text tid={"OrderSuccess"} /> {json.dataSet[0]["erpFicheNo"]}</>, {
                        hideProgressBar: true,
                        autoClose: false,
                    });

                    props.onSlipDeleteAllLines();

                } else {
                    toast.error(json.resMessage);
                }

                props.toggleLoadingOverlay(false);

                setPaymentTrackingId("");
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error(error);
                props.toggleLoadingOverlay(false);

            }
        };
        fetchData();
    };


    const paypalApiURL = "https://paypal.mobiapi.de/api/paypal";

    const createOrder = async () => {
        try {
            const res = await axios.post(paypalApiURL + "/create-order", {
                amount: amount / 100,
                currency: "EUR",
                token: sessionStorage.getItem('token'),
                vendorId: VENDORID,
            });
            setPaymentTrackingId(res.data.id);
            return res.data.id;
        } catch (err) {
            console.error("Create Order Error:", err);
        }
    };

    const onApprove = async (data) => {
        try {
            const res = await axios.post(paypalApiURL + "/capture-order", {
                orderID: data.orderID,
                token: sessionStorage.getItem('token'),
                vendorId: VENDORID,
            });
            handlePaymentSuccess();
            //     alert("Ödeme başarılı!");
        } catch (err) {
            console.error("Capture Order Error:", err);
            alert("Ödeme alınamadı.");
        }
    };


    // Stiller
    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        overflowY: "auto",
    };

    const modalStyle = {
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "8px",
        width: "100%",
        maxWidth: "550px",
        maxHeight: "95vh",
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
        overflowY: "auto",
    };

    const scrollableContentStyle = {
        overflowY: "auto",
        flex: 1,
    };

    const closeButtonStyle = {
        marginTop: "20px",
        backgroundColor: "#ccc",
        border: "none",
        padding: "8px 16px",
        borderRadius: "4px",
        cursor: "pointer",
    };


    return (
        <div className=" text-white p-6">

            {/* Step bar */}
            <div className="flex justify-between mb-6 text-sm font-semibold">
                {steps.map((label, index) => (
                    <div
                        key={index}
                        className={`flex-1 text-center border-b-2 pb-2 ${currentStep === index
                            ? "border-red-500 text-red-400"
                            : currentStep > index
                                ? "border-green-500 text-green-300"
                                : "border-gray-600 text-gray-400"
                            }`}
                    >
                        {label}
                    </div>
                ))}
            </div>

            {/*  soldaki özet kutuları */}
            <div className="flex gap-6">
                <div className="w-1/4 space-y-4">
                    <div className="bg-gray-800 p-4 rounded-lg">
                        <h3 className="text-sm font-bold"><Text tid={"EmailAddress"} /></h3>
                        <p className="text-xs">{sessionStorage.getItem('email')}</p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg">
                        <h3 className="text-sm font-bold"><Text tid={"BillingAddress"} /></h3>
                        <p className="text-xs">{data && data[0].erpCustomerName1}
                            <br />{data && data[0].erpCustomerAddress1}
                            <br />{data && data[0].erpCustomerCityPostalCode}&nbsp; {data && data[0].erpCustomerCityName}
                            <br />{data && data[0].erpCustomerCountryName}
                        </p>
                    </div>
                    {(data) && (
                        <div className="bg-gray-800 p-4 rounded-lg">
                            <div className="flex items-center justify-between">
                                <h3 className="text-sm font-bold"><Text tid={"ShippingAddress"} /></h3>


                            </div>

                            {data[0].erpShippingAdrCityName === "" && (<p className="text-xs">{data && data[0].erpCustomerName1}
                                <br />{data && data[0].erpCustomerAddress1}
                                <br />{data && data[0].erpCustomerCityPostalCode}&nbsp; {data && data[0].erpCustomerCityName}
                                <br />{data && data[0].erpCustomerCountryName}
                            </p>)}
                            {data[0].erpShippingAdrCityName !== "" && (
                                <p className="text-xs">{data[0].erpShippingAdrName1 } {data[0].erpShippingAdrName2}
                                    <br />{data[0].erpShippingAdrAddress1} {data[0].erpShippingAdrAddress2}
                                    <br />{data[0].erpShippingAdrPostalCode}&nbsp; {data[0].erpShippingAdrCityName}
                                    <br />{data[0].erpShippingAdrCountryName}
                                </p>)}
                        </div>

                    )}

                    {false && (
                        <div className="bg-gray-800 p-4 rounded-lg">
                            <div className="flex items-center justify-between">
                                <h3 className="text-sm font-bold"><Text tid={"PaymentType"} /></h3>

                                <button
                                    onClick={() => setCurrentStep(1)}
                                    className="hover:text-gray-500 ml-2"
                                    aria-label="Edit Shipping Address"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M11 5h6M5 19l4-4H5v4zM13 7l4 4L7 21H3v-4L13 7z" />
                                    </svg>
                                </button>
                            </div>
                            <p className="text-xs">{selectedPaymentMethod}</p>
                        </div>
                    )}
                </div>

                {/* Sağ form */}
                <div className="w-3/4 rounded-lg">

                    {false && (
                        < div style={{ display: currentStep === 0 ? 'block' : 'none' }}>
                        <ShippingAddressForm address={address} setAddress={setAddress} />
                    </div>
                    )}

                    {/* Step 1: Payment */}

                    {(paymentType === "stripe_embed") &&
                        <div style={{ display: currentStep === 1 && paymentType === "stripe_embed" ? 'block' : 'none' }}>
                            <StripePay
                                ref={stripeRef}
                                amount={amount}
                                setSelectedPaymentMethod={setSelectedPaymentMethod}
                                startPayment={startPayment}
                                checkPayment={checkPayment}
                                props={props}
                            />
                        </div>
                    }


                    {/* Step 2: Review */}
                    <div style={{ display: 1 === ((paymentType == "paypal" || paymentType == "stripe") ? 1 : 2) ? 'block' : 'none' }}>
                        {table}
                        <div className="text-gray-400 mt-4">
                        <label className="inline-flex items-center space-x-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={terms}
                                onChange={(e) => setTerms(e.target.checked)}
                                className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-600">
                                <Text tid={"IAgreeToTerms"} />
                            </span>
                        </label>
                    </div>
                    </div>



                    <div className="mt-6 flex gap-4 ">

                        <div className="flex-1"></div>
                        {(true) && (
                            <button
                                onClick={async () => {



                                    if (currentStep === 1 && paymentType === "stripe_embed") {
                                        const isValid = await stripeRef.current?.handleCardValidation();
                                        if (!isValid) {
                                            return;

                                        }
                                        //   setCheckPayment((prev) => prev+1)

                                    }

                                    if (paymentType === "paypal") {
                                        setPayPalModalOpen(true)
                                        return;
                                    }

                                    if (paymentType === "stripe") {
                                        props.toggleLoadingOverlay(true);
                                        axios.post(PAYMENTSERVER + "/create-checkout-webshop", {
                                            "amount": amount,
                                            "token": sessionStorage.getItem('token'),
                                            "vendorId": VENDORID,
                                            "siteUrl": window.location.origin,
                                        })
                                            .then((response) => {
                                                if (response.data.resCode !== 200) {
                                                    toast.error(response.data.resMessage || "An error occured");
                                                    props.toggleLoadingOverlay(false);
                                                    return;
                                                }
                                                const url = response.data.url;

                                                if (url) {
                                                    window.location.href = url;
                                                    setTimeout(() => {
                                                        props.toggleLoadingOverlay(false);
                                                    }, 2000);

                                                } else {
                                                    toast.error(response.data.resMessage || "An error occured");
                                                }
                                            })
                                            .catch((error) => {
                                                toast.error(error.message || "An error occured");
                                            });

                                        return;
                                    }

                                    if (currentStep === 2 && paymentType === "stripe_embed") {
                                        props.toggleLoadingOverlay(true);
                                        setStartPayment((prev) => prev + 1)

                                        return;
                                    }
                                    setCurrentStep((prev) => Math.min(steps.length - 1, prev + 1))
                                }}
                                className={`px-6 py-2 rounded text-white bg-green-600 hover:bg-green-700 ${terms ? "opacity-100" : "opacity-50 "}`}
                                disabled={!terms}
                            >
                                <Text tid={"CompletePayment"} />
                            </button>
                        )}


                        {currentStep === 1 && (paymentType === "paypal" || paymentType === "stripe") && (
                            <div>


                                {isPayPalModalOpen && (
                                    <div style={overlayStyle}>
                                        <div style={modalStyle}>
                                            <div className="sticky top-0 flex flex-row gap-3 mb-4 justify-between p-1  border-solid border-slate-200 rounded-t w-full h-18 z-10">
                                                <button
                                                    className="border-0 text-black  flex items-center h-6 opacity-50 text-3xl font-semibold outline-none focus:outline-none"
                                                    onClick={() => {
                                                        setPayPalModalOpen(false);
                                                    }}
                                                >
                                                    <span className="bg-transparent text-black hover:text-gray-500 h-6 w-6 text-xl flex items-centers justify-center outline-none focus:outline-none">
                                                        &#10006;
                                                    </span>
                                                </button>



                                            </div>
                                            <div style={scrollableContentStyle}>
                                                <PayPalScriptProvider options={{ "client-id": "test", currency: "EUR" }}>
                                                    <PayPalButtons
                                                        style={{ layout: "vertical" }}
                                                        createOrder={(data, actions) => createOrder()}
                                                        onApprove={(data, actions) => onApprove(data)}
                                                        onError={(err) => {
                                                            console.error("PayPal Error:", err);
                                                            alert(err.message || "Bir hata oluştu.");
                                                        }}
                                                    />
                                                </PayPalScriptProvider>
                                            </div>

                                        </div>
                                    </div>
                                )}
                            </div>
                        )}


                    </div>
                </div>
            </div>
        </div >
    );


};

export default CheckoutScreen;
